import { bsc } from "viem/chains";

export const DEFAULT_CHAIN_ID = 56;
export const chains = [bsc]
export const projectId = process.env.REACT_APP_PROJECT_ID;
export const projectName = process.env.REACT_APP_PROJECT_NAME;
export const projectDesc = process.env.REACT_APP_PROJECT_DESC;
export const projectUrl = process.env.REACT_APP_PROJECT_URL;
export const projectIcon = process.env.REACT_APP_PROJECT_ICON;
export const modalColorCode = process.env.REACT_APP_CONNECT_MODAL_COLOR_CODE;
export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
